/**
 * Contractors API
 * Handles contractor/worker related API calls
 */

import { buildApiUrl } from './config';
import { fetchWithTokenRefresh } from './refreshToken';

export interface WorkingHours {
  id: string;
  contractorId: string;
  dayOfWeek: number; // 0-6 (Monday=0, Sunday=6)
  startTime: string; // "HH:mm" format
  endTime: string; // "HH:mm" format
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Service {
  id: string;
  contractorId: string;
  categoryId: string;
  name: string;
  description?: string;
  price?: number;
  unit?: string; // e.g., "per hour", "per service"
  createdAt: string;
  updatedAt: string;
  category: {
    id: string;
    nameEn: string;
    nameFr: string;
  };
}

/**
 * Get contractor services by ID
 */
export async function getContractorServices(contractorId: string): Promise<Service[]> {
  const url = buildApiUrl(`/contractors/${contractorId}/services`);
  const response = await fetchWithTokenRefresh(url);
  return response.json();
}

/**
 * Get contractor working hours by ID
 */
export async function getContractorWorkingHours(contractorId: string): Promise<WorkingHours[]> {
  const url = buildApiUrl(`/contractors/${contractorId}/working-hours`);
  const response = await fetchWithTokenRefresh(url);
  return response.json();
}

/**
 * Export all contractor API functions
 */
export const contractorsApi = {
  getServices: getContractorServices,
  getWorkingHours: getContractorWorkingHours,
};
